module.exports = __webpack_public_path__ + "static/DuotoneLiam-fbaa8fb986bff47363a4f113fd70c743.png";